
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarSouth as ObiBuoyPilarSouthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-south.js';
 
 
 

 
 export const ObiBuoyPilarSouth = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-south',
   elementClass: ObiBuoyPilarSouthElement,
   events: {
     
   }
  });
 
 